module.exports = function(app) {
    app.directive('customSsnValidate', ['$state','services','storage','session',
        function($state, services, storage, session) {

            return {
                require: 'ngModel',
                restrict: 'A',
                member: {},
                link:function(scope, elm, attrs, ctrl){

                    ctrl.$validators.checnkbeginSsnDigits = function(modelValue, viewValue){

                        modelValue = modelValue || "";
                        var regExpValid = /^((?!666|000|9\d{2})\d{3})$/;
                        return ( (modelValue != "") &&  (regExpValid.test (modelValue)));
                    };
                    ctrl.$validators.disallowNumberSequence = function(modelValue, viewValue){

                        modelValue = modelValue || "";
                        var disallowedSsnArray = ["123"+"-45-"+"6789", "219"+"-09-"+"9999", "078"+"-05-"+"1120"];
                        return ( (modelValue != "") &&  (disallowedSsnArray.indexOf(modelValue) >= 0));
                        //Old Code below
                        //var regExpValid = /^(?!123-45-6789|219-09-9999|078-05-1120)$/;
                        //return  regExpValid.test (modelValue);
                    };
                    ctrl.$validators.disallowzeroGroupNum = function(modelValue, viewValue){
                        //console.log('disallowzeroGroupNum modelValue: ', modelValue);
                        modelValue = modelValue || "";
                        var regExpValid = /^((?!00)\d{2})$/;
                        return  ( (modelValue != "") &&  (regExpValid.test (modelValue)));
                    };
                    ctrl.$validators.checklastSsnDigits = function(modelValue, viewValue){
                       // console.log('checklastSsnDigits modelValue: ', modelValue);
                        modelValue = modelValue || "";
                        var regExpValid = /^((?!0{4})\d{4})$/;
                        return  ( (modelValue != "") &&  (regExpValid.test (modelValue)));
                    };
                 }
            };
        }
    ]);
};
